import {
  AutoCompleteOption,
  MenuOption,
  MenuSelectOption,
  MultiSelectOption,
} from '@equip.health/ui';

export const toAutoCompleteOption = (value: string): AutoCompleteOption => ({
  primaryText: value,
  value,
});

export const toMenuOption = (value: string): MenuOption => ({
  node: value,
  value,
});

export const toMenuSelectOption = (value: string): MenuSelectOption => ({
  displayNode: value,
  node: value,
  value,
});

export const toMultiSelectOption = (value: string): MultiSelectOption => ({
  label: value,
  value,
});
export const toStateMenuOption = (value: {
  label: string;
  externalId: string;
}): MenuOption => ({
  node: value.label,
  value: value.externalId,
});

export const toStateMenuOptionInCoverage = (value: {
  label: string;
  externalId: string;
}): MenuOption => ({
  node: value.label,
  value: value.label,
});

export const toTagsUniversalOption = (value: {
  label: string;
}): UniversalSelectOption => ({
  label: value.label,
  value: value.label,
});
